/**
 * TA-10891: remembers (per browser tab) when the user last signed in, so
 * post-login onboarding behaviour can be limited to the first minute of a
 * fresh session instead of firing on every page load with a restored token.
 * Web only — sessionStorage is absent on native, where every call is a no-op.
 */
const LOGIN_SUCCEEDED_AT_KEY = 'login_succeeded_at';

export const LOGIN_WINDOW_MS = 60_000;

const storage = (): Storage | undefined => {
  try {
    return globalThis.sessionStorage ?? undefined;
  } catch {
    return undefined;
  }
};

export const markLoginSucceeded = (now: number = Date.now()) => {
  storage()?.setItem(LOGIN_SUCCEEDED_AT_KEY, String(now));
};

export const clearLoginSucceeded = () => {
  storage()?.removeItem(LOGIN_SUCCEEDED_AT_KEY);
};

/** Milliseconds since the last sign-in, or undefined if none is recorded. */
export const msSinceLoginSucceeded = (
  now: number = Date.now()
): number | undefined => {
  const raw = storage()?.getItem(LOGIN_SUCCEEDED_AT_KEY);
  const at = raw ? Number(raw) : NaN;
  return Number.isFinite(at) ? now - at : undefined;
};

export const isWithinLoginWindow = (
  now: number = Date.now(),
  windowMs: number = LOGIN_WINDOW_MS
): boolean => {
  const elapsed = msSinceLoginSucceeded(now);
  return elapsed !== undefined && elapsed >= 0 && elapsed <= windowMs;
};
